export default __webpack_public_path__ + "images/2L.1240780.png";